import { v4 as uuid } from 'uuid';

export const getRequestId = () => {
  return uuid();
};
